import React from "react"

// className is destructured rather than left in rest: in rest it landed after the computed
// className on the element and silently replaced it, so a caller could not add a modifier such as
// btn--outlined without losing btn and btn--small. No existing caller passes one.
const Button = ({ type = "button", variant, className, children, animate, ...rest }) => (
    <button
        type={type}
        className={`btn ${variant ? `btn--${variant}` : ""} ${animate ? `btn--animate` : ""} ${className ?? ""}`.replace(/\s+/g, " ").trim()}
        {...rest}
    >
        {children}
    </button>
)

export default Button
